<template>
  <div>
    <AssetBuyModal :open="modalIsOpened('addDealBuy')"
                   @close="toggleModal('addDealBuy')"/>
    <AssetSellModal :open="modalIsOpened('addDealSell')"
                    @close="toggleModal('addDealSell')"/>
    <ManualIncomesModal :open="modalIsOpened('addManualIncome')"
                        @close="toggleModal('addManualIncome')"/>
    <ManualExpensesModal :open="modalIsOpened('addManualExpense')"
                         @close="toggleModal('addManualExpense')"/>
    <ImportPortfolioModal :import-opened="modalIsOpened('importPortfolio')"
                          @close="toggleModal('importPortfolio')"/>
    <TransferInBalanceModal :open="modalIsOpened('transferInBalance')"
                            @close="toggleModal('transferInBalance')"/>
    <TransferOutBalanceModal :open="modalIsOpened('transferOutBalance')"
                             @close="toggleModal('transferOutBalance')"/>
    <AssetBuyEditModal :open="modalIsOpened('editDealBuy')"
                       :deal="editingDeal"
                       @close="handleCloseEditModal('editDealBuy')"/>
    <AssetSellEditModal :open="modalIsOpened('editDealSell')"
                        :deal="editingDeal"
                        @close="handleCloseEditModal('editDealSell')"/>
    <ManualIncomesEditModal :open="modalIsOpened('editManualIncome')"
                            :deal="editingDeal"
                            @close="handleCloseEditModal('editManualIncome')"/>
    <ManualExpensesEditModal :open="modalIsOpened('editManualExpense')"
                             :deal="editingDeal"
                             @close="handleCloseEditModal('editManualExpense')"/>
    <TransferInEditModal :open="modalIsOpened('editTransferIn')"
                         :deal="editingDeal"
                         @close="handleCloseEditModal('editTransferIn')"/>
    <TransferOutEditModal :open="modalIsOpened('editTransferOut')"
                          :deal="editingDeal"
                          @close="handleCloseEditModal('editTransferOut')"/>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import ImportPortfolioModal from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioModal";
import AssetBuyModal from "@/components/cabinet/Investments/modals/AssetBuyModal";
import AssetSellModal from "@/components/cabinet/Investments/modals/AssetSellModal";
import ManualExpensesModal from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualExpensesModal";
import ManualIncomesModal from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualIncomesModal";
import TransferInBalanceModal from "@/components/cabinet/Investments/modals/TransferInBalanceModal";
import TransferOutBalanceModal from "@/components/cabinet/Investments/modals/TransferOutBalanceModal";
import AssetBuyEditModal from "@/components/cabinet/Investments/modals/AssetBuyEditModal";
import AssetSellEditModal from "@/components/cabinet/Investments/modals/AssetSellEditModal";
import ManualIncomesEditModal from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualIncomesEditModal";
import ManualExpensesEditModal from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualExpensesEditModal";
import TransferInEditModal from "@/components/cabinet/Investments/modals/TransferInEditModal";
import TransferOutEditModal from "@/components/cabinet/Investments/modals/TransferOutEditModal";

/*  todo refactor as <component is/>
      AssetBuy: false,
      AssetSell: false,
      ManualIncome: false,
      ManualExpense: false,
      ImportPortfolio: false,
      TransferInBalance: false,
      TransferOutBalance: false,*/

export default {
  name: "InvestmentsModals",
  components: {
    AssetBuyModal,
    AssetSellModal,
    ImportPortfolioModal,
    ManualIncomesModal,
    ManualExpensesModal,
    TransferOutBalanceModal,
    TransferInBalanceModal,
    AssetBuyEditModal,
    AssetSellEditModal,
    ManualIncomesEditModal,
    ManualExpensesEditModal,
    TransferInEditModal,
    TransferOutEditModal,
  },
  computed: {
    ...mapGetters('investments/modals', ['modalIsOpened']),
    ...mapState('investments/modals', ['editingDeal']),
  },
  methods: {
    ...mapMutations('investments/modals', ['toggleModal', 'clearEditingDeal']),
    handleCloseEditModal(modalName) {
      this.toggleModal(modalName);
      this.clearEditingDeal();
    }
  }
}
</script>

<style scoped>

</style>